import {
  GET_RANK_HISTORY,
  SHOW_RANK_HISTORY,
  CREATE_RANK_HISTORY,
  EDIT_RANK_HISTORY,
  DELETE_RANK_HISTORY
} from "@/store/modules/mutation-types";

export default {
  state: {},
  getters: {},
  actions: {
    async [GET_RANK_HISTORY]({ dispatch }, params) {
      const res = await dispatch("apiGet", {
        url: "/kanri/rank_histories",
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [SHOW_RANK_HISTORY]({ dispatch }, params) {
      let url = "/kanri/rank_histories/" + params.id;
      const res = await dispatch("apiGet", {
        url: url,
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [CREATE_RANK_HISTORY]({ dispatch }, params) {
      let url = "/kanri/rank_histories/rank_history_create";
      const res = await dispatch("apiPost", {
        url: url,
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [EDIT_RANK_HISTORY]({ dispatch }, params) {
      let url = "/kanri/rank_histories/" + params.id;
      const res = await dispatch("apiPatch", {
        url: url,
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [DELETE_RANK_HISTORY]({ dispatch }, params) {
      let url = "/kanri/rank_histories/" + params.id;
      const res = await dispatch("apiDelete", {
        url: url,
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    }
  },
  mutations: {}
};
